export function shuffle(items, random = Math.random) {
  const result = [...items];
  for (let index = result.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(random() * (index + 1));
    [result[index], result[swapIndex]] = [result[swapIndex], result[index]];
  }
  return result;
}

export function createQueue(words, previousWord = null, random = Math.random) {
  if (words.length < 2 || !previousWord) return shuffle(words, random);

  const firstChoices = words.filter(({ word }) => word !== previousWord);
  if (firstChoices.length === words.length) return shuffle(words, random);

  // Choose the first word from all non-previous entries, then shuffle the rest.
  const firstIndex = Math.floor(random() * firstChoices.length);
  const first = firstChoices[firstIndex];
  return [first, ...shuffle(words.filter((entry) => entry !== first), random)];
}

export function createRound(entry, random = Math.random) {
  return {
    word: entry.word,
    answer: entry.emoji,
    choices: shuffle(entry.choices, random),
  };
}

export function isCorrectChoice(round, choiceIndex) {
  return round.choices[choiceIndex] === round.answer;
}
